/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const PaymentMethodEnum = Object.freeze({
  NULL: 'NULL',
  PAYPAL: 'PAYPAL',
  PAYPAL_SANDBOX: 'PAYPAL_SANDBOX',
  STRIPE: 'STRIPE',
  STRIPE_TESTING: 'STRIPE_TESTING',
});

export default PaymentMethodEnum;
